const SLIDERS = [
  {
    title: "Vodafone",
    addr: "Boglarka Dobias, IT Manager - BI & Data Analytics",
		text: "We sincerely appreciate efficient, gracious customer service, the level of detail " +
      "and accountability that the CyberVision team has demonstrated on each assignment, and " +
      "the way they conduct business as a whole. We are delighted by the quality of their " +
      "responsiveness and professionalism, very reliable. The CyberVision team demonstrated " +
      "full commitment and professionalism not only in actual deliverables but also during the " +
      "Knowledge Transfer sessions. Keep up the good job. Thank you so much, and we will be looking " +
      "forward to an excellent continuing business relationship."
  },
  {
    title: "Outset",
    addr: "Bhavesh Patel, VP of Software",
    text: "Outset is a pioneering medical technology company focused on changing the way dialysis is delivered. " +
      "Outset's consumer-driven design approach is aimed at service model innovation that will dramatically improve" +
      " the care experience for patients and lower costs for providers. Outset is a company of ambitious and bold innovators" +
      " and we look for the same traits in our partners. We have found this partner in CyberVision as well as the best" +
      " middleware technology which fit our technological demands as well as FDA and HIPAA regulations. The team at " +
      "CyberVision has proved to be not only experts in the IoT realm, but also in various engineering initiatives " +
      "including data analytics, telemetry, embedded development, and architecture. CyberVision was able to meet all " +
      "of our requirements for a successful deployment of our product."
  }
];

export default SLIDERS;
